import React from 'react';

import { Box, Button, Divider, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ReactHookFormCheckboxButtonGroup from 'common/components/form/ReactHookFormCheckboxButtonGroup';

const SelectDocumentsForm = ({ callback, documents, onSave }) => {
    const { t } = useTranslation();
    const { control, handleSubmit } = useForm({
        defaultValues: {
            catalog_documents: '',
        },
    });

    const handleOnClickSave = (values) => onSave(values, callback);

    return (
        <Stack component="form">
            <ReactHookFormCheckboxButtonGroup
                control={control}
                items={documents.map((doc) => ({
                    label: doc.name,
                    value: doc.id,
                }))}
                name="catalog_documents"
            />

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box sx={{ textAlign: 'right' }}>
                <Button onClick={handleSubmit(handleOnClickSave)}>
                    {t('Save')}
                </Button>
            </Box>
        </Stack>
    );
};

SelectDocumentsForm.propTypes = {
    callback: PropTypes.func,
    documents: PropTypes.array,
    onSave: PropTypes.func,
};

export default SelectDocumentsForm;
